import * as gfxref from "../actions/gfxref";
import { IGfxRef } from "../../ref/IGfxRef";

export function reducer(state: IGfxRef = null, action: gfxref.GfxRefAction) {
    if (action.type == gfxref.UPDATEREF) {
        return Object.assign({}, action.getRef());;
    } else
        return state;
}